// Decisioni sulla registrazione alle notifiche push. La regola è in docs/SpecsSezioni.md,
// "Notifiche push — registrazione": qui solo le decisioni, così si possono provare con i test.

// Nota sul dispositivo: "questo utente si è iscritto alle notifiche da qui". Sta fuori dai dati utente,
// quindi il logout non la cancella. Il rinnovo silenzioso del token parte solo se c'è.
const pushRegisteredKey = (userId) => `easyjob_push_registered_${userId}`;

export function markPushRegisteredHere(userId) {
  try {
    if (userId) localStorage.setItem(pushRegisteredKey(userId), "1");
  } catch (_) {
    // ignorato di proposito
  }
}

export function wasPushRegisteredHere(userId) {
  try {
    return Boolean(userId) && localStorage.getItem(pushRegisteredKey(userId)) === "1";
  } catch (_) {
    return false;
  }
}

// In automatico (al login) l'iscrizione si propone, con la domanda, solo a chi non ha nessun token.
// Chi ne ha già uno si iscrive a mano da Info utente.
export function automaticRegistration({ backendHasAnyToken }) {
  return backendHasAnyToken ? "skip" : "ask";
}

// Rinnovo silenzioso del token: solo con il permesso già concesso e se l'utente si era già iscritto da
// questo dispositivo. "resubscribe": il browser ha perso l'iscrizione, se ne crea una nuova e si registra;
// "register": il token del browser non risulta su Cedolino, si registra di nuovo; "none": niente.
export function silentRenewal({ permission, registeredHere, hasSubscription, tokenMatch }) {
  if (permission !== "granted" || !registeredHere) return "none";
  if (!hasSubscription) return "resubscribe";
  if (!tokenMatch) return "register";
  return "none";
}

// Registra: prima il permesso, poi la cancellazione dell'iscrizione esistente. Se il permesso non
// arriva, requirePermission lancia e l'iscrizione esistente resta com'è.
export async function unsubscribeAfterPermission(registration, requirePermission) {
  await requirePermission();
  try {
    const existing = await registration.pushManager.getSubscription();
    if (existing) {
      await existing.unsubscribe();
    }
  } catch (err) {
    console.warn("Impossibile disiscrivere la subscription esistente", err);
  }
}
